export const filterRowers = (rowers, searchTerm, selectedTrainingGroup) => {
  return rowers.filter((rower) => {
    // Search filter
    const matchesSearch =
      !searchTerm ||
      `${rower.first_name} ${rower.last_name}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      rower.email.toLowerCase().includes(searchTerm.toLowerCase());

    // Training group filter
    const matchesTrainingGroup =
      selectedTrainingGroup === 'all' ||
      (rower.training_groups &&
        rower.training_groups.some((tg) => tg.id.toString() === selectedTrainingGroup.toString()));

    return matchesSearch && matchesTrainingGroup;
  });
};

export const isRowerAssigned = (rower, crew) => {
  if (!crew) return false;
  return crew.members.some((member) => member.user_id === rower.id);
};
